<template>
  <v-container class="d-flex flex-column ga-3">
    <v-row>
      <v-col>
        <UsageExample
          v-model="tab"
          :code="code"
          :tabs="tabs"
          class="compact-usage-example"
        ></UsageExample>

        <UsageExample
          v-model="dataTab"
          :code="code2"
          :tabs="dataTabs"
          class="compact-usage-example mb-10"
        ></UsageExample>

        <v-card elevation="4" class="one-level-card">
          <div class="font-weight-bold px-2">One Level</div>
          <div class="py-2">
            <cs-option-select
              id="one-level-option-select"
              :items="oneLevelItems"
              :show-chip="true"
              :show-searchbar="false"
              :is-primary="false"
              :is-nested="false"
              label="Example Elementary School"
              :chip-props="{ color: 'teal', label: 'Parent site' }"
              :style="{ marginRight: '180px' }"
              @update:option-select-value="handleSelection"
            >
            </cs-option-select>

            <cs-option-select
              id="one-level-option-select-searchbar"
              :items="oneLevelItems"
              :show-chip="false"
              :show-searchbar="true"
              :is-primary="true"
              :is-nested="false"
              tooltip-direction="left"
              label="Go to section"
              @update:option-select-value="handleSelection"
            >
            </cs-option-select>
          </div>
        </v-card>

        <v-card elevation="4" class="two-level-card">
          <div class="font-weight-bold px-2">Two Levels</div>
          <div class="py-2">
            <cs-option-select
              id="two-level-option-select"
              :items="twoLevelItems"
              :show-chip="true"
              :show-searchbar="false"
              :is-primary="false"
              :is-nested="true"
              label="Example Elementary School"
              :chip-props="{ color: 'teal', label: 'Parent site' }"
              :style="{ marginRight: '180px' }"
              @update:option-select-value="handleSelection"
            >
            </cs-option-select>

            <cs-option-select
              id="two-level-option-select-searchbar"
              :items="twoLevelItems"
              :show-chip="false"
              :show-searchbar="true"
              :is-primary="true"
              :is-nested="true"
              tooltip-direction="left"
              label="Go to section"
              @update:option-select-value="handleSelection"
            >
            </cs-option-select>
          </div>
        </v-card>

        <v-card elevation="4" class="six-level-card">
          <div class="font-weight-bold px-2">Six Levels</div>
          <div class="py-2">
            <cs-option-select
              id="six-level-option-select"
              :items="sixLevelItems"
              :show-chip="true"
              :show-searchbar="false"
              :is-primary="false"
              :is-nested="true"
              label="Example Elementary School"
              :chip-props="{ color: 'teal', label: 'Parent site' }"
              :style="{ marginRight: '180px' }"
              @update:option-select-value="handleSelection"
            >
            </cs-option-select>

            <cs-option-select
              id="six-level-option-select-searchbar"
              :items="sixLevelItems"
              :show-chip="false"
              :show-searchbar="true"
              :is-primary="true"
              :is-nested="true"
              tooltip-direction="left"
              label="Go to section"
              @update:option-select-value="handleSelection"
            >
            </cs-option-select>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'CSOptionSelect',
  components: {
    UsageExample
  },

  setup() {
    const code = `// With Chip and Without Searchbar
<template>
  <cs-option-select
          id="option-select-with-chip-and-without-searchbar"
          :items="items"
          :show-chip="true"
          :show-searchbar="false"
          :is-primary="false"
          :is-nested="true"
          label="Example Elementary School"
          :chip-props="{ color: 'teal', label: 'Parent site' }"
          @update:option-select-value="handleSelection"
        >
  </cs-option-select>

// Without Chip and With Searchbar
  <cs-option-select
          id="option-select-without-chip-and-with-searchbar"
          :items="items"
          :show-chip="false"
          :show-searchbar="true"
          :is-primary="true"
          :is-nested="true"
          tooltip-direction="left"
          label="Go to section"
          @update:option-select-value="handleSelection"
        >
  </cs-option-select>
</template>
`;

    const code2 = `export default {
  data() {
    return {
      // One Level Items
      oneLevelItems: [
        { title: 'Example Site Name' },
        { title: 'Example Site Name' },
        { title: 'Example Site Name' },
        { title: 'Example Site Name' },
        {
          title: 'Example Site Name'
        }
      ],

      // Two Level Items
      twoLevelItems: [
        {
          title: 'Example Site Name',
          children: [
            { title: 'Example Site Name' },
            {
              title: 'Example Site Name'
            }
          ]
        },
        { title: 'Example Site Name' },
        { title: 'Example Site Name' },
        { title: 'Example Site Name' },
        { title: 'Example Site Name' }
      ],

      // Six Level Items
      sixLevelItems: [
        {
          title: 'Example Site Name',
          children: [
            {
              title: 'Example Site Name',
              children: [
                {
                  title: 'Example Site Name',
                  children: [
                    {
                      title: 'Example Site Name',
                      children: [
                        {
                          title: 'Example Site Name',
                          children: [
                            {
                              title: 'Example Site Name'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        { title: 'Example Site Name' },
        { title: 'Example Site Name' },
        { title: 'Example Site Name' },
        { title: 'Example Site Name' }
      ]
    };
  }
};`;

    return {
      code,
      code2
    };
  },

  data() {
    return {
      tab: 'Option Select Usage',
      tabs: ['Option Select Usage'],
      dataTab: 'Items Data Structure',
      dataTabs: ['Items Data Structure'],

      isSelected: true,
      isExpanded: false,
      isDisabled: false,
      isDropdownOpen: false,

      chipProps: {
        label: 'Parent site'
      },

      oneLevelItems: [
        { title: 'Example Site Name' },
        { title: 'Example Site Name' },
        { title: 'Example Site Name' },
        { title: 'Example Site Name' },
        {
          title: 'Example Site Name with longer content string that requires truncation and tooltip'
        }
      ],

      twoLevelItems: [
        {
          title: 'Example Site Name',
          children: [
            { title: 'Example Site Name' },
            {
              title:
                'Example Site Name with longer content string that requires truncation and tooltip'
            }
          ]
        },
        { title: 'Example Site Name' },
        { title: 'Example Site Name' },
        { title: 'Example Site Name' },
        { title: 'Example Site Name' }
      ],

      sixLevelItems: [
        {
          title: 'Example Site Name',
          children: [
            {
              title: 'Example Site Name',
              children: [
                {
                  title: 'Example Site Name',
                  children: [
                    {
                      title: 'Example Site Name',
                      children: [
                        {
                          title: 'Example Site Name',
                          children: [
                            {
                              title:
                                'Example Site Name with a much longer content string that requires truncation and tooltip'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        { title: 'Example Site Name' },
        { title: 'Example Site Name' },
        { title: 'Example Site Name' },
        { title: 'Example Site Name' }
      ]
    };
  },

  methods: {
    handleSelection(value) {
      console.log('Selected item:', value);
    }
  }
};
</script>

<style scoped>
.one-level-card,
.two-level-card,
.six-level-card {
  height: 120px;
  overflow: visible;
  transition: height 0.3s ease;

  padding: 20px;
  margin-bottom: 40px;
}

:deep(.compact-usage-example .v-sheet) {
  min-height: auto !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.one-level-card:has(.cs-option-select__dropdown[style*='display: block']),
.one-level-card:has(.cs-option-select__dropdown:not([style*='display: none'])) {
  height: 400px;
}

.two-level-card:has(.cs-option-select__dropdown[style*='display: block']),
.two-level-card:has(.cs-option-select__dropdown:not([style*='display: none'])) {
  height: 500px;
}

.six-level-card:has(.cs-option-select__dropdown[style*='display: block']),
.six-level-card:has(.cs-option-select__dropdown:not([style*='display: none'])) {
  height: 600px;
}
</style>
